// src/pages/forecast/floodforecast/FloodforecastMap/fetchLatestObserve.js
import Papa from 'papaparse';
import moment from 'moment';

/**
 * fetch ค่าตรวจวัดล่าสุด (wl) ของสถานีเดียว
 * คืนค่า number หรือ null
 */
export const fetchLatestWl = (stationId) => {
  const agencyId = 9;
  const startDate = moment().subtract(2, 'days').format('YYYY-MM-DD');
  const toDate    = moment().add(1, 'days').format('YYYY-MM-DD');

  return fetch(
    `${process.env.REACT_APP_API_URL}/public/waterlevel_graph_oldcode` +
    `?station_id=${stationId}&agency_id=${agencyId}` +
    `&start_date=${startDate}&end_date=${toDate}`
  )
    .then(r => r.ok ? r.json() : null)
    .then(result => {
      const graphData = result?.data?.graph_data;
      if (!graphData?.length) return null;
      const valid = [...graphData].reverse().find(
        n => n.value !== null && !Number.isNaN(parseFloat(n.value))
      );
      return valid ? parseFloat(valid.value) : null;
    })
    .catch(() => null);
};

/**
 * fetch ค่าตรวจวัดล่าสุด (discharge) ของสถานีเดียว
 * คืนค่า number หรือ null
 */
export const fetchLatestDischarge = (stationId) => {
  return fetch(
    `${process.env.REACT_APP_THAIWATER_URL}/proxy/txt.php` +
    `?file=${process.env.REACT_APP_FEWS_URL}/model-output/data_portal/rid_discharge/observe/${stationId}.txt`
  )
    .then(r => r.ok ? r.text() : null)
    .then(text => {
      if (!text) return null;
      const rows = Papa.parse(text).data;
      const valid = [...rows].reverse().find(
        row => row[3] && !Number.isNaN(parseFloat(row[3]))
      );
      return valid ? parseFloat(valid[3]) : null;
    })
    .catch(() => null);
};

/**
 * fetch ทุกสถานีพร้อมกัน คืน { stationId: value }
 */
export const fetchAllLatestWl = (stations) => {
  return Promise.all(
    stations.map(d =>
      fetchLatestWl(d[0]).then(value => ({ id: d[0], value }))
    )
  ).then(results => {
    const map = {};
    results.forEach(({ id, value }) => { map[id] = value; });
    return map;
  });
};

export const fetchAllLatestDischarge = (stations) => {
  return Promise.all(
    stations.map(d =>
      fetchLatestDischarge(d[0]).then(value => ({ id: d[0], value }))
    )
  ).then(results => {
    const map = {};
    results.forEach(({ id, value }) => { map[id] = value; });
    return map;
  });
};